<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-card>
      <v-form ref="form">
        <v-card-title>
          <span class="headline">Titles</span>
        </v-card-title>
        <v-alert
          v-show="!!error"
          text
          prominent
          type="error"
          icon="mdi-alert-circle"
          >{{ error }}</v-alert
        >
        <v-alert
          v-show="!!success"
          text
          prominent
          type="success"
          icon="mdi-cloud-check"
          >Succesfully Created</v-alert
        >
        <v-container>
          <v-row v-if="hasAuth('Titles', 'New Title')">
            <v-col cols="1" sm="1" md="1"></v-col>
            <v-col cols="8" sm="3" md="8">
              <v-text-field
                v-model="name"
                label="Name"
                required
                maxlength="100"
                counter
                dense
                :rules="nameRules"
              ></v-text-field>
            </v-col>
            <v-col cols="2" sm="1" md="2">
              <v-btn color="primary" depressed v-on:click="save">Add</v-btn>
            </v-col>
            <v-col cols="1" sm="1" md="1"></v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="12">
              <v-data-table
                :headers="headers"
                :items="titles"
                class="shadow-xl mx-5 my-5"
                :search="search"
                hide-default-footer
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-row>
                      <v-col cols="10" sm="3" md="4" offset-md="8" class="px-5">
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip bottom v-if="hasAuth('Titles', 'Delete Title')">
                    <template v-slot:activator="{ on }">
                      <v-btn depressed @click="deleteTitle(item.Id)" v-on="on">
                        <v-icon size="18">delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete Title</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data></template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="toggleDialog">Close</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  FETCH_TITLES,
  CREATE_TITLE,
  DELETE_TITLE,
  TOGGLE_TITLE_DIALOG,
} from "../../store/modules/digistaff";
import { hasActionAuthorization } from "../../authorization";

export default {
  data: () => ({
    headers: [
      {
        text: "Name",
        value: "Name",
      },
      {
        text: "Actions",
        value: "action",
        align: "right",
      },
    ],
    search: "",
    name: "",
    code: "",
    editName: "",
    nameRules: [(v) => !!v || "Title name is required"],
  }),
  computed: {
    ...mapState("digistaff", {
      titles: (state) => state.titles,
      isLoading: (state) => state.titleIsLoading,
      dialog: (state) => state.titleDialog,
      success: (state) =>
        state.createTitle.success || state.deleteTitle.success,
      error: (state) => state.createTitle.error || state.deleteTitle.error,
    }),
  },
  methods: {
    ...mapActions("digistaff", {
      fetchTitles: FETCH_TITLES,
      createTitle: CREATE_TITLE,
      deleteTitle: DELETE_TITLE,
      toggleDialog: TOGGLE_TITLE_DIALOG,
    }),
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.createTitle({ Name: this.name });
      this.name = "";
    },
    hasAuth(page, action) {
      return hasActionAuthorization(this.$store, page, action);
    },
  },
};
</script>
